<template lang="pug">
  #app
    transition(name="routerView")
      router-view
</template>

<script>
// import router from './router'
export default {
  name: 'App'
}
</script>

<style lang="scss">
  @import "/style/settings.scss";
  @import "/style/main.scss";

  $fonts-dir: './assets/fonts';
  @font-face {
    font-family: "Noto sans";
    font-weight: 400;
    src: url('#{$fonts-dir}/NotoSans-Regular.ttf') format('truetype');
  }
  @font-face {
    font-family: "Noto sans";
    font-weight: 700;
    src: url('#{$fonts-dir}/NotoSans-Bold.ttf') format('truetype');
  }
  @font-face {
    font-family: "Mononoki";
    font-weight: 400;
    src: url('#{$fonts-dir}/mononoki-Regular.ttf') format('woff2'),
      url('#{$fonts-dir}/mononoki-Regular.ttf') format('woff'),
      url('#{$fonts-dir}/mononoki-Regular.ttf') format('truetype');
  }
  @font-face {
    font-family: "Mononoki";
    font-weight: 400;
    font-style: italic;
    src: url('#{$fonts-dir}/mononoki-Italic.ttf') format('woff2'),
      url('#{$fonts-dir}/mononoki-Italic.ttf') format('woff'),
      url('#{$fonts-dir}/mononoki-Italic.ttf') format('truetype');
  }
  @font-face {
    font-family: "Mononoki";
    font-weight: 700;
    src: url('#{$fonts-dir}/mononoki-Bold.ttf') format('woff2'),
      url('#{$fonts-dir}/mononoki-Bold.ttf') format('woff'),
      url('#{$fonts-dir}/mononoki-Bold.ttf') format('truetype');
  }
  @font-face {
    font-family: "Mononoki";
    font-weight: 700;
    font-style: italic;
    src: url('#{$fonts-dir}/mononoki-BoldItalic.ttf') format('woff2'),
      url('#{$fonts-dir}/mononoki-BoldItalic.ttf') format('woff'),
      url('#{$fonts-dir}/mononoki-BoldItalic.ttf') format('truetype');
  }

  .routerView-enter-active, .routerView-leave-active {
    transition: opacity .2s;
  }
  .routerView-enter, .routerView-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue